import { atom } from 'recoil'

export default atom({
    key: 'toggleOptions',
    default: {},
})
